const types = {
  'pdf': [ 'application/pdf' ],
  'xml': [ 'application/xml', 'text/xml' ],
  'xls': [ 'application/xls', 'text/csv', 'application/vnd.ms-excel' ],
  'jpg': ['image/jpeg'],
  'gif': ['image/gif'],
  'xslt': [ 'application/xslt', 'application/xslt+xml', 'text/xslt' ]
}

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return args.reduce((acc, ft) => {
      if (acc) return acc
      if (!types[ft]) return false
      return types[ft].some(x => x === value.type)
    }, false)
  }
}
